<template>
    <div class='auth-status'>
        <!--失败时： 用icon-iconfontguanbi fail替换icon-duihao2 bg-color-->
        <div class='iconfont icon-duihao2 bg-color'></div>

        <div class='status'>{{ msg }}</div>
        <!--客服二维码  -->
        <div class="constomerQr" v-if="customerQrUrl != ''">
            <div class="tips">请长按添加客服号，加速审核并安排发货等事宜</div>
            <div class='qr'>
                <img :src='customerQrUrl' class="qr-image"></img>
            </div>
        </div>
        <button class='backToPage' @click="backToLastPage" hover-class='none'>返回我的页面</button>
        <button class='returnBnt cart-color' @click="goIndex" hover-class='none'>返回首页</button>
    </div>
</template>
<script>
import { getCustomerQr } from "@api/public"

export default {
    name: "AuthStatus",
    components: {
    },
    props: {},
    data: function () {
        return {
            msg: this.$route.query.msg,
            customerQrUrl: ''
        };
    },
    mounted: function () {
        this.getCustomerQr();
    },
    methods: {
        getCustomerQr() {
            getCustomerQr().then(res => {
                this.customerQrUrl = res.data.customerQrUrl
            });
        },
        backToLastPage(){
            this.$router.replace('/user').catch(err => { });
        },
        goIndex(){
            this.$router.replace('/').catch(err => { });
        }
    }
};
</script>
<style>
.auth-status {
  background-color: #fff;
  margin: 1.5rem auto 0 auto;
  border-radius: 0.1rem;
  padding: 0.01rem 0 0.28rem 0;
  width: 6.9rem;
  left: 50%;
  margin-left: -3.45rem;
  text-align: center;
}


.auth-status .iconfont {
  font-size: 0.70rem;
  width: 1.40rem;
  height: 1.40rem;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 1.40rem;
  text-shadow: 0px 4px 0px #df1e14;
  border: 0.06rem solid #f5f5f5;
  margin: -0.76rem auto 0 auto;
  background-color: #999;
}

.auth-status .status {
  font-size: 0.32rem;
  font-weight: bold;
  text-align: center;
  margin: 0.22rem 0 0.37rem 0;
}

.auth-status .wrapper {
  border: 0.01rem solid #eee;
  margin: 0 0.30rem 0.47rem 0.30rem;
  padding: 0.35rem 0;
  border-left: 0;
  border-right: 0;
}

.auth-status .backToPage {
  width: 6.30rem;
  height: 0.86rem;
  border-radius: 0.50rem;
  color: #3E3841;
  font-size: 0.30rem;
  text-align: center;
  line-height: 0.86rem;
  margin: 0 auto 0.20rem auto;
  border: 1px solid #3E3841;
}

.auth-status .returnBnt {
  width: 6.30rem;
  height: 0.86rem;
  border-radius: 0.50rem;
  color: #fff;
  font-size: 0.30rem;
  text-align: center;
  line-height: 0.86rem;
  margin: 0.30rem auto 0.30rem auto;
}

.auth-status .constomerQr {
  border-bottom: 1px solid #eee;
  margin: 0.47rem 0.30rem 0.47rem 0.30rem;
  padding-top: 0.35rem;
  border-left: 0;
  border-right: 0;
}

.auth-status .constomerQr .tips {
  font-size: 0.26rem;
  text-align: center;
  color:#666;
}

.auth-status .constomerQr .qr {
  text-align: center;
}
.auth-status .constomerQr .qr .qr-image {
  width: 4.50rem;
  height: 4.50rem;
}
</style>

